import { ArrowRightIcon } from "@heroicons/react/24/outline";
import Link from "next/link";
import useTranslation from "next-translate/useTranslation";

export const PartnerCta = () => {
  const { t } = useTranslation("contact");

  return (
    <section
      aria-labelledby="partner-cta-title"
      // -mb-8 znosi margines stopki (mt-8), aby pas łączył się ze stopką
      className="-mb-8 border-white/10 border-b bg-[#051124] text-white"
    >
      <div className="mx-auto flex max-w-7xl flex-col gap-6 px-4 py-12 sm:px-6 md:flex-row md:items-center md:justify-between md:py-14 lg:px-8">
        <div>
          <h2
            className="font-bold text-2xl tracking-tight md:text-3xl"
            id="partner-cta-title"
          >
            {t("cta.title")}
          </h2>
          <p className="mt-2 text-white/70">{t("cta.description")}</p>
        </div>
        <div className="flex flex-col gap-3 sm:flex-row">
          <Link
            className="inline-flex items-center justify-center gap-2 rounded-md bg-[#c1a166] px-5 py-3 font-semibold text-[#051124] text-sm transition hover:bg-[#d4b77a] focus-visible:outline-2 focus-visible:outline-white focus-visible:outline-offset-2"
            href="/partners"
          >
            {t("cta.partners")}
            <ArrowRightIcon aria-hidden="true" className="size-4" />
          </Link>
          <Link
            className="inline-flex items-center justify-center rounded-md border border-white/30 px-5 py-3 font-semibold text-sm text-white transition hover:border-white hover:bg-white/10 focus-visible:outline-2 focus-visible:outline-white focus-visible:outline-offset-2"
            href="/advertising-materials"
          >
            {t("cta.catalogs")}
          </Link>
        </div>
      </div>
    </section>
  );
};
